import React from "react";
import TestimonialCard from "./TestimonialCard";

const Testimonials = () => {
  return (
    <div class="bg-lemongreen h-auto flex flex-col">
      <div class="flex flex-col justify-center items-center md:p-20 md:pb-28 p-4">
        <div class="mb-10">
          <h1 class="font-karla uppercase font-bold text-lemongray text-2xl">
            Testimonials
          </h1>
        </div>
        <div class="grid md:grid-rows-1 grid-cols-2 lg:grid-cols-4 gap-4 justify-center items-center">
          <TestimonialCard
            rating={5}
            img="https://randomuser.me/api/portraits/women/77.jpg"
            name="Jane K."
            desc="Excellent food, best Lemon Dessert I’ve ever had in my life. You should check Little Lemon out today!"
          ></TestimonialCard>
          <TestimonialCard
            rating={4}
            img="https://randomuser.me/api/portraits/men/19.jpg"
            name="Carl J."
            desc="Service was impeccable,  Chef’s talent was unmatched. Host was slightly rude at front."
          ></TestimonialCard>
          <TestimonialCard
            rating={5}
            img="https://randomuser.me/api/portraits/women/74.jpg"
            name="Megan C."
            desc="The Greek Salad reminded me of home. Whatever is in the Chicago style Feta is basically a drug."
          ></TestimonialCard>
          <TestimonialCard
            rating={3}
            img="https://randomuser.me/api/portraits/men/41.jpg"
            name="Paul S."
            desc="Awful. I’ve had better Bruschetta at Olive Garden. Not sure why this has so many good reviews."
          ></TestimonialCard>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
